module.exports = __webpack_public_path__ + "img/into_banner.69fc8602.jpg";